import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { ResponseModel,GenericApiResponseModel } from "@model/api.model";
import { TokenService } from '@services/rest/token.service';
import { ChangePasswordModel } from "@model/change-password.model";
import { UserAddEditModel, UserModel, UserRequestModel } from "@model/staff.model";

@Injectable({
    providedIn: "root",
})
export class StaffApiService {


    formHeaders  = new HttpHeaders({
        'Authorization': `Bearer ${this.tokenService.getAccessToken()}`
      });

    constructor(
        private http: HttpClient,
        private tokenService: TokenService,
        ) {
    }

    changePassword(model: ChangePasswordModel): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/staff/ChangePassword', model,{headers: this.formHeaders}
        );
    }

    getUserList(model: UserRequestModel): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/staff/list', model
        );
    }

    setPassword(id :string,password: string): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/staff/SetPassword/{id}/{password}'
                    .replace("{password}",password)
                    .replace("{id}",id), 
                    ''
        );
    }

    createUser(userAddModel: UserAddEditModel): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/staff/create', userAddModel
        );
    }

    editUser(model: UserAddEditModel): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/staff/edit', model
        );
    }

    getUser(id: string): Observable<ResponseModel<GenericApiResponseModel<UserModel>>> {
        return this.http.get<ResponseModel<GenericApiResponseModel<UserModel>>>(
            '/staff/{id}'.replace("{id}",id)
        );
    }

    getOnlineStatus(): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.get<ResponseModel<GenericApiResponseModel<any>>>(
            '/staff/OnlineStatus'
        );
    }
}
